import React from 'react';
import { Button, Typography } from '@material-ui/core';

import { useStyles } from './styles';
import { DeleteModalProps } from './types';
import { Modal } from '../../../../../components/migrated/modal';
import { useSupplierContext } from 'contexts/complementaryRegistration';

export const ModalDeleteAssignor = (props: DeleteModalProps) => {
  const { row, open, handleClose, personIdLogged } = props;
  const classes = useStyles();
  const { setSupplierData, setHasChanges } = useSupplierContext();

  const onDelete = () => {
    setSupplierData((prevSupplierData) => {
      const assignorToDeleteIndex = prevSupplierData.assignors.findIndex(
        (assignorItem) =>
          (assignorItem.item.idFCed !== null && row.idFCed !== null && assignorItem.item.idFCed === row.idFCed) ||
          (assignorItem.item.cpf !== null && row.cpf !== null && assignorItem.item.cpf === row.cpf) ||
          (assignorItem.item.cnpj !== null && row.cnpj !== null && assignorItem.item.cnpj === row.cnpj)
      );

      const updatedAssignorArray = [...prevSupplierData.assignors];

      if (assignorToDeleteIndex !== -1) {
        if (updatedAssignorArray[assignorToDeleteIndex].operation === 'I') {
          updatedAssignorArray.splice(assignorToDeleteIndex, 1);
          setHasChanges(false);
        } else {
          updatedAssignorArray[assignorToDeleteIndex] = {
            operation: 'E',
            item: updatedAssignorArray[assignorToDeleteIndex].item
          };
          setHasChanges(true);
        }
      }

      return {
        ...prevSupplierData,
        personIdOperation: +personIdLogged,
        assignors: updatedAssignorArray
      };
    });

    handleClose();
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      hideClose
      disableBackdropClick
      disableEscapeKeyDown
      title="EXCLUIR REGISTRO DE CEDENTE"
    >
      <div className={classes.root}>
        <div style={{ marginTop: '24px' }}>
          <Typography>Tem certeza que deseja excluir o registro?</Typography>
        </div>
        <div className={classes.buttons}>
          <Button variant="text" color="primary" onClick={handleClose}>
            Cancelar
          </Button>
          <Button className={classes.deleteButton} variant="contained" color="primary" onClick={onDelete}>
            Excluir
          </Button>
        </div>
      </div>
    </Modal>
  );
};
